import { Component, OnInit } from '@angular/core';
import { Contatos } from 'src/app/persistences/contatos';
import { ContaService } from 'src/app/services/conta.service';

@Component({
  standalone: false,
  selector: 'app-contatos',
  templateUrl: './contatos.component.html',
  styleUrls: ['./contatos.component.css']
})
export class ContatosComponent implements OnInit {

  contato: Contatos;

  constructor(
    private contaService: ContaService
  ){}

  ngOnInit(): void {
    this.contaService.getContatos().subscribe((contato)=>{
      this.contato = contato;
    });
  }

  formataCelular(value: string): string {
    if (!value) return value;

    value = value.replace(/\D/g, '');

    const ddd = value.substring(0, 2);
    const firstPart = value.substring(2, 7);
    const secondPart = value.substring(7, 11);

    if (value.length > 10) {
      return `(${ddd}) ${firstPart}-${secondPart}`;
    } else if (value.length > 6) {
      return `(${ddd}) ${firstPart}-${secondPart}`;
    } else {
      return value;
    }
  }

}
